import React from "react";
import './conventions.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import {insertHtml} from "../../utils/dom";

class Conventions extends TemplateComponent {

    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: {
                targetId: null
            },
            targetId:''
        };
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);

        this.requireInternationalization = true;
    }

    openModal(e) {
        this.setState({ isModalOpen: { targetId: Number(e.currentTarget.dataset.id)}})
    }

    closeModal () {
        this.setState({ isModalOpen: { targetId: null}})
    }

    internationalComponentRender(data, t) {

        return (
            <div id={"conventions"}>
                {(data.title) &&
                    <h3 className={"title"}>{data.title}</h3>
                }
                {(data.content) &&
                    <div className={"content col-md-8 p-0"} {...insertHtml(data.content)} />
                }
                <div className="conventions-container">
                    <div className={'grid-data-container d-flex flex-wrap'}>
                        {data.conventions.map((el, index) =>(
                            <>
                                <div key={index} className={'box-convention col-md-4 p-0'}>
                                    <div className={'element-wrap'}>
                                        <h4 className={'category'}>{el.category}</h4>
                                        <p>{el.title}</p>
                                    </div>
                                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                                    <a className={(this.state.isModalOpen.targetId === index)? 'd-none' : ""} data-id={index} onClick={this.openModal}>
                                        {t("C57 open label")}
                                    </a>
                                </div>
                                <Modal key={Math.random()*100}
                                       data-id={index} {...el}
                                        t={t}
                                       isOpen={this.state.isModalOpen.targetId === index}
                                       onClose={this.closeModal}/>
                            </>
                        ))}
                    </div>
                    {(data.show_more_link) &&
                        <a href={data.show_more_link} className={'btn-white'}>
                            Tutte le Convenzioni
                        </a>
                    }
                </div>

            </div>
        )
    }
}


class Modal extends React.Component {
    render () {
        const { isOpen, onClose, t } = this.props;
        return (
            <div className={isOpen ? 'modal modal-open' : 'modal'}>
                <span className={'close-button'} onClick={onClose} />
                <h4>{this.props.title}</h4>
                <div className={'main-content-box'} {...insertHtml(this.props.content)} />
                {(this.props.contacts.length > 0) && <h6>Contatti</h6>}
                <div className={'grid-contact d-flex flex-wrap'}>
                    {(this.props.contacts.length > 0 || this.props.contacts) && this.props.contacts.map((el, index) =>(
                        <div className={'contact-box col-sm-6'} key={"conventions-" + index}>
                            {(el.address) &&
                                <div className={'address'}>
                                    <span className={'maps-icon'} />
                                    <a href={`https://www.google.com/maps/place/${el.lat ? el.lat : ""},${el.long ? el.long : ""}`}
                                       target={'_blank'} rel="noopener noreferrer">{el.address}</a>
                                </div>
                            }
                            {(el.phone) &&
                                <div className={'phone'}>
                                    <span className={"phone-icon"}/>
                                    <span>{el.phone}</span>
                                </div>
                            }
                        </div>
                    ))}
                </div>
                {(this.props.web_link) &&
                    <a href={this.props.web_link} className={'btn-white'} target={'_blank'} rel="noopener noreferrer">
                        {t("C57 website label")}
                    </a>
                }
            </div>
        );
    }
}

export default Conventions;